import type { RetainerAgreementWithFileDetails } from '@common/types/retainerAgreements';
import { Chip, Stack, Typography } from '@mui/material';

interface Props {
    retainer: RetainerAgreementWithFileDetails;
    isTemplateDefault: boolean;
}

/** A retainer's file name, with a badge for a template default or one for all users */
export default function RetainerLabel({ retainer, isTemplateDefault }: Props) {
    // A template default is always for all users, so it only needs its own badge
    const badge = isTemplateDefault
        ? 'Template Default'
        : retainer.userId === null
          ? 'All Users'
          : null;

    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: '100%', minWidth: 0 }}
        >
            <Typography variant="body2" fontWeight={500} color="text.primary" noWrap>
                {retainer.fileName || 'No file uploaded'}
            </Typography>
            {badge && (
                <Chip
                    label={badge}
                    size="small"
                    sx={{
                        flexShrink: 0,
                        fontWeight: 500,
                        bgcolor: isTemplateDefault ? 'primary.P_50' : 'neutral.N_50',
                        color: isTemplateDefault ? 'primary.main' : 'neutral.N_700',
                    }}
                />
            )}
        </Stack>
    );
}
